(function(){

    window.adev = window.adev || {};

    window.adev = {
        init(){
            this.popup();
            this.productCards();
        },
        popup(){
            document.addEventListener('adev:popup:open', (e) => {
                const id = e.detail;
                const popup = document.querySelector(`[data-adev-popup="${id}"]`);
                if (popup) {
                    popup.classList.add('opened');
                }
            });

            document.addEventListener('adev:popup:close', (e) => {
                const popup = document.querySelector(`[data-adev-popup]`);
                if (popup) {
                    popup.classList.remove('opened');
                }
            });

            
            document.querySelectorAll('[data-adev-open-popup]:not(.adev-init)').forEach((el) => {
                el.classList.add('adev-init');

                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    const id = el.getAttribute('data-adev-open-popup');

                    document.dispatchEvent(
                        new CustomEvent('adev:popup:open', {
                            detail: id
                        })
                    );
                });

            });

            document.querySelectorAll('[data-adev-close-popup]:not(.adev-init)').forEach((el) => {
                el.classList.add('adev-init');

                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    document.dispatchEvent(
                        new CustomEvent('adev:popup:close')
                    );
                });

            });


            const urlParams = new URLSearchParams(window.location.search);
            const form_type = urlParams.get('form_type');
            const contact_posted = urlParams.get('contact_posted');
            const errorParams = 'contact' === form_type && '#wholesale-form' === window.location.hash;
            const posted = 'true' === contact_posted && '#wholesale-form' === window.location.hash;

            console.log(contact_posted);
            console.log(posted);
            

            if (errorParams || posted) {
                document.dispatchEvent(
                    new CustomEvent('adev:popup:open', {
                        detail: 'adev-wholesale-form'
                    })
                );
            }
        },
        productCards(){
            document.querySelectorAll('[data-adev-product-card]:not(.adev-init)').forEach((el) => {
                el.classList.add('adev-init');
                
                const quickAdd = el.querySelector('[data-adev-pc-quick-add]');

                quickAdd.addEventListener('click', (e) => {
                    e.preventDefault();
                    
                    el.classList.add('added');
                });

            });
        },
    }

    window.adev.init();

})();